export default __webpack_public_path__ + "static/tab-img-f039c27e1abd9512c67d2c2535e9a9e4.png";